import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken } from '@/utils/jwt';

const AGENT_MCP_URL = import.meta.env.VITE_AGENT_MCP_URL as string | undefined;

export interface ToolInfo {
  name: string;
  description: string;
  parameters?: Record<string, unknown>;
  allowed: boolean;
}

export interface ToolsResponse {
  success: boolean;
  tools: ToolInfo[];
  total: number;
}

export const toolsApi = createApi({
  reducerPath: 'toolsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: AGENT_MCP_URL ?? '/agent',
    prepareHeaders: (headers) => {
      const token = getAccessToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTools: builder.query<ToolsResponse, undefined>({
      query: () => '/tools',
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetToolsQuery } = toolsApi;
